import dayjs from "dayjs";

export function parseTimeOnDate(selectedDate, timeStr) {
  if (!timeStr) return null;
  const base = selectedDate?.format?.("YYYY-MM-DD");
  if (!base) return null;
  const d = dayjs(`${base}T${timeStr}`);
  return d.isValid() ? d : null;
}

export function filterTransfers(transfers, { airportFilter = "", nameFilter = "" }) {
  const af = (airportFilter || "").toLowerCase().trim();
  const nf = (nameFilter || "").toLowerCase().trim();

  return (transfers || []).filter((t) => {
    const matchesName = !nf || (t.name || "").toLowerCase().includes(nf);

    if (!af) return matchesName;

    const dep = (t.departing || "").toLowerCase();
    const arr = (t.destination || "").toLowerCase();
    const fromCampus = (t.fromCampus || t.fromCampusName || "").toLowerCase();
    const toCampus = (t.toCampus || t.toCampusName || "").toLowerCase();

    const matchesAirport =
      dep.includes(af) ||
      arr.includes(af) ||
      fromCampus.includes(af) ||
      toCampus.includes(af);

    return matchesName && matchesAirport;
  });
}

export function sortTransfers(transfers, selectedDate) {
  return [...(transfers || [])].sort((a, b) => {
    const ta = parseTimeOnDate(selectedDate, a.direction === "IN" ? a.arrivalTime : a.departureTime);
    const tb = parseTimeOnDate(selectedDate, b.direction === "IN" ? b.arrivalTime : b.departureTime);
    if (!ta) return 1;
    if (!tb) return -1;
    return ta.unix() - tb.unix();
  });
}

export function groupTransfersByCampus(sortedTransfers) {
  const internal = (sortedTransfers || []).filter((t) => t.direction === "INTERNAL");
  const external = (sortedTransfers || []).filter((t) => t.direction !== "INTERNAL");

  const grouped = external.reduce((acc, t) => {
    const key = t.campus || "Unknown";
    if (!acc[key]) acc[key] = [];
    acc[key].push(t);
    return acc;
  }, {});

  if (internal.length > 0) grouped["Internal Transfers"] = internal;
  return grouped;
}
